<template>
	<div class="document inspection-summary p-4">
		<div class="mb-5">
			<div class="grid">
				<div class="col-8 document-title">
					<p>BUILDING ACT 2004 </p>
					<p>
						ANNUAL IQP INSPECTION SUMMARY DEFECT REPORT
					</p>
				</div>
				<div class="col-4 css-image compass-logo mt-2">
				</div>
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Building name</b><br />
				<span>{{propertyData.propertyName}}</span>
			</div>
			<div class="col-6 doc-border ">
				<b>Date</b><br />
				<span>{{formattedDate(new Date())}}</span>
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Address</b><br />
				<span>
					&nbsp;{{owner.streetAddress}}
					&nbsp;{{owner.suburb}}
					&nbsp;{{owner.city}}
				</span>
			</div>
			<div class="col-6 doc-border ">
				<b>Inspection</b><br />
				<span>Annual BWOF renewal</span>
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Building Owner</b><br />
				<span>{{owner.companyName}}</span>
			</div>
			<div class="col-6 doc-border ">
				<b>Defect Notice No.</b><br />
				<span></span>
			</div>
		</div>
		<div class="grid inspection-row" style="padding:4px;min-height:100px;">
			<div class="col-12 doc-border">
				<b>Defects:</b><br />
				<div contenteditable="true" class="p-inputtext inspection-comment" />
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Issued By: </b><br />
				<span>{{bwof.issuedBy}} - Compass New Zealand Ltd</span>
			</div>
			<div class="col-6 doc-border ">
				<b>Date</b><br />
				<span>{{formattedDate(bwof.issuedDate)}}</span>
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Signed By: </b><br />
				<span>{{bwof.issuedBy}}</span>
			</div>
			<div class="col-6 doc-border ">
				<b>Date</b><br />
				<span>{{formattedDate(bwof.issuedDate)}}</span>
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Date Rectified</b><br />
				<div contenteditable="true" class="p-inputtext inspection-comment" />
			</div>
			<div class="col-6 doc-border ">
				<b>Date</b><br />
				<span>{{formattedDate(new Date())}}</span>
			</div>
		</div>
		<div class="grid inspection-row">
			<div class="col-6 doc-border ">
				<b>Comment</b><br />
				<div contenteditable="true" class="p-inputtext inspection-comment" />
			</div>
			<div class="col-6 doc-border ">
			</div>
		</div>
	</div>
	<div class="document css-image compliance-schedule-defect-report-fees" style="height: 842px;">
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, CompanyData, PropertyBwofData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';

	@Options({
		name: 'DocumentBwof',
		props: {
			propertyData: null
		}
	})
	export default class InspectionTemplate extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();

		bwof: PropertyBwofData = new PropertyBwofData();

		owner: CompanyData = new CompanyData();

		dateRectified = '';

		comment = '';

		created() {
			this.bwof = this.propertyData.propertyBwof != null ? this.propertyData.propertyBwof : this.bwof;
			this.owner = this.propertyData.owner != null ? this.propertyData.owner : this.owner;

		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'd MMMM yyyy');
		}
	}
</script>

<style>
	.inspection-comment {
		height: 60px;
		resize: vertical;
		overflow: auto;
	}
</style>